import React, { Component } from "react";

import Table from "../../common/table";
import FileType from "./fileType";
import Actions from "../../common/table/actions";

class FilesTable extends Component {
  columns = [
    {
      path: "type",
      label: "View",
      content: (file) => <FileType type={file.type} />,
    },
    { path: "name", label: "Name", isSortable: true },
    { path: "parent", label: "Folder", isSortable: true },
    { path: "url", label: "URL", isSortable: false },
    {
      key: "actions",
      label: "Actions",
      isSortable: false,
      content: (file) => (
        <Actions
          onClick={() => this.props.onDelete(file)}
          path="file"
          item={file}
          name={true}
        />
      ),
    },
  ];

  render() {
    const { images, startNumber, onSort, sortColumn } = this.props;
    return (
      <Table
        columns={this.columns}
        data={images}
        sortColumn={sortColumn}
        onSort={onSort}
        startNumber={startNumber}
      />
    );
  }
}

export default FilesTable;
